import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { UploadTypes } from '@catmodules/models/userdata-generation/types';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'catapp-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
})
export class ImageUploadComponent implements OnInit, OnDestroy {

  @Input() changing: Subject<boolean>;
  @Output() public changed: EventEmitter<any> = new EventEmitter();
  @Input() label: string;
  @Input() selectedUploadOption: UploadTypes = UploadTypes.None;
  @Input() form: FormGroup;
  @Input() dropdownOptions = [
    { label: 'None', value: UploadTypes.None },
    { label: 'Default', value: UploadTypes.Default },
    { label: 'Upload', value: UploadTypes.Upload },
  ];
  @Input()
  set defaultImageUrl(val: string) {
    this.defaultImage = this.sanitizer.bypassSecurityTrustUrl(val);
  }
  @Input() dropdownControlName: string;
  @Input() uploadControlName: string;
  @Input() filenameControlName: string;
  @Input() imageBase64: SafeUrl = null;

  imageUrl: SafeUrl = null;
  defaultImage: SafeUrl;
  defaultImageLoaded = false;
  loadingImage = false;
  checkType: any = UploadTypes;

  correctImageFormat = true;
  correctImageSize = true;
  /**
   * Creates an instance of image upload component.
   * @param sanitizer
   */
  constructor(private sanitizer: DomSanitizer) { }

  /**
   * on init
   */
  ngOnInit() {
    this.changing.subscribe((v) => {
      this.updateImageSelection();
    });
  }

  /**
   * Determines whether image loaded on
   */
  onImageLoaded(evt) {
    this.loadingImage = false;
      if (this.selectedUploadOption === UploadTypes.Default && this.defaultImageLoaded === false) {
      this.defaultImageLoaded = true;
    }
    if (evt && evt.target) {
      this.correctImageSize = (evt.target.naturalWidth >= 1920 && evt.target.naturalHeight >= 1080);
      this.correctImageFormat = ((evt.target.naturalWidth / evt.target.naturalHeight) === (16 / 9));
    }
  }

  /**
   * on destroy
   */
  ngOnDestroy() {
  }

  /**
   * read the provided file-stream and set it as the to be used icon file
   * @param $event
   */
  updateImageFile($event) {
    this.updateFile($event, (name: string, value: string) => {
      if (value && name) {
        this.form.controls[this.filenameControlName].patchValue(name);
        this.form.controls[this.uploadControlName].patchValue(value);
        this.loadingImage = true;
        this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(value);
        this.form.get(this.uploadControlName).markAsDirty();
      }
    });
  }

  /**
   * Updates image selection
   */
  updateImageSelection() {
    this.selectedUploadOption = this.form.controls[this.dropdownControlName].value;
    this.correctImageSize = true;
    this.correctImageFormat = true;
    if (this.selectedUploadOption === UploadTypes.Default && this.defaultImageLoaded === false) {
      this.loadingImage = true;
    }
    this.changed.emit();
  }

  /**
   * Updates file
   * @param $event
   * @param onFinish
   */
  private updateFile($event, onFinish: (name: string, value: string) => void) {
    const fileReader = new FileReader();
    const fileInfo = $event.target.files[0];
    const fileName = fileInfo.name;
    this.loadingImage = true;
    this.imageUrl = null;
    fileReader.onload = (fileEvent: any) => {
      const uploadTarget: any = fileEvent.target;
      const fileContent = `${encodeURI(uploadTarget.result)}`;
      onFinish(fileName, fileContent);
    };
    fileReader.readAsDataURL(fileInfo);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/userdata-generation/components/image-upload/image-upload.component.ts